<template>
   <section class="app-main">
    <transition name="slide-fade" mode="out-in">
      <keep-alive>
          <router-view v-if="$route.meta.keepAlive"/>
      </keep-alive>
    </transition>

    <transition name="slide-fade" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive"/>
    </transition>

  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style>
  .slide-fade {
    position: absolute;
    left: 0;
    right: 0;
  }
  .slide-fade-enter-active {
    transition: all 0.2s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(2, 0.5, 0.8, 1);
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    left: 0;
    right: 0;
    opacity: 0;
  }
</style>


// WEBPACK FOOTER //
// src/layout/components/appMain.vue